/*
 *
 * MessagesHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 20-Mar-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import MessagesHomePopups from './MessagesHomePopups'
import { nullSafe } from 'Utility/globalMethods'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TriggerTimelineActions, dispatch)

})

const mapStateToProps = (state) => ({
  newsInfo: nullSafe(() => state.triggerTimeline.current.additionalInfo, ''),
  isLoading: nullSafe(() => state.loading.localLoading.set_retrieve_ttl_read, false),
  isTTLread: nullSafe(() => state.triggerTimeline.isTTLread, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(MessagesHomePopups)
